import type { FunctionComponent, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { useIsIntersecting } from '../../../hooks/useIsIntersecting';

interface ObservedElementProps extends IntersectionObserverInit {
  onIntersect?: () => void;
  onFirstIntersect?: () => void;
  onIntersectChange?: (isIntersecting: boolean) => void;
}

export const ObservedElement: FunctionComponent<PropsWithChildren<ObservedElementProps>> = ({
  rootMargin,
  threshold,
  onIntersect = () => null,
  onFirstIntersect = () => null,
  onIntersectChange = () => null,
  children,
}) => {
  const { setNode, isIntersecting } = useIsIntersecting({ rootMargin, threshold });
  const [hasIntersected, setHasIntersected] = useState<boolean>(isIntersecting);

  useEffect(() => {
    if (isIntersecting && !hasIntersected) {
      onFirstIntersect();
      setHasIntersected(true);
    }

    onIntersectChange(isIntersecting);
    if (isIntersecting) {
      onIntersect();
    }
  }, [isIntersecting, hasIntersected, onIntersect, onFirstIntersect, onIntersectChange]);

  return <div ref={setNode}>{children}</div>;
};
